import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBm5wFHyl-fYrGI28HskB6QH9TocObu-oc",
  authDomain: "hammersawpaint.firebaseapp.com",
  databaseURL: "https://hammersawpaint-default-rtdb.firebaseio.com",
  projectId: "hammersawpaint",
  storageBucket: "hammersawpaint.firebasestorage.app",
  messagingSenderId: "918051666432",
  appId: "1:918051666432:web:e5534ef8e6bb244cd8f6e5",
  measurementId: "G-RR6H9GK856"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Firebase Storage and get a reference to the service
export const storage = getStorage(app);

// Initialize Firebase Analytics
let analytics = null;
if (typeof window !== 'undefined') {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
      console.log('Firebase Analytics initialized successfully');
    } else {
      console.log('Firebase Analytics not supported in this environment');
    }
  }).catch((error) => {
    console.error('Error initializing Firebase Analytics:', error);
  });
}
export { analytics };

export default app;
